import React, { useEffect, useState } from 'react'
import { anime } from 'react-anime';
import { Button, TextField, Typography, Box, FormControl } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useSettings } from '../../contexts/SettingsProvider';
import { isBlank } from '../../util/util'

interface IEnterNameProps {
    onFinishEnteringName: (name: string, isSpectator: boolean) => void
}

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        padding: '0 24px 32px',
        boxSizing: 'border-box',
        overflow: 'hidden',
    },
    form: {
        width: '100%',
        maxWidth: 400,
        [theme.breakpoints.down('sm')]: {
            maxWidth: '100%',
        },
    },
    buttons: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
    },
}))

export default function EnterName({ onFinishEnteringName }: IEnterNameProps) {
    const classes = useStyles()

    const [nameText, setNameText] = useState("")
    const { name, setName } = useSettings()

    let isSpectator = false

    function onEnterSelected() {
        onFinishEnteringName(nameText, isSpectator)
        setName(nameText)
    }

    function onSpectateSelected() {
        isSpectator = true
        onEnterSelected()
    }

    function handleNameChanged(e: React.ChangeEvent<HTMLInputElement>) {
        setNameText(e.target.value)
    }

    useEffect(() => {
        anime({
            targets: ".animFadeIn",
            scale: [0.55, 1],
            opacity: [0, 1],
            easing: 'easeInOutSine',
            duration: 200
        })
        setNameText(name)
    }, [])

    return (
        <div className={classes.root}>

            <Box className="animFadeIn" maxWidth="sm" style={{ textAlign: "center", width: "100%" }}>
                <Box m={2}>
                    <Typography variant="h4">
                        Enter your name
                    </Typography>
                </Box>
                <FormControl className={classes.form}>
                    <TextField
                        id="name-field"
                        label="Name"
                        variant="outlined"
                        inputProps={{ maxLength: 30 }}
                        onChange={handleNameChanged}
                        defaultValue={name}
                        style={{ marginBottom: "16px" }} />
                </FormControl>
                <Box m={2} className={classes.buttons}>
                    <Button
                        variant="contained"
                        color="primary"
                        style={{ margin: "8px", width: "150px" }}
                        onClick={onEnterSelected}
                        disabled={isBlank(nameText)}>
                        Join
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        style={{ margin: "8px", width: "150px" }}
                        onClick={onSpectateSelected}
                        disabled={isBlank(nameText)}>
                        Spectate
                    </Button>
                </Box>
            </Box>

        </div>
    )
}
